import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { highChartClockConfig } from '../widgets/components/base-highchart/highcharts-config';
import { Options } from 'highcharts';

@Component({
  selector: 'app-gauge-clock',
  templateUrl: './gauge-clock.component.html',
  styleUrl: './gauge-clock.component.scss',
})
export class GaugeClockComponent implements OnInit {
  @Input() timeZone: string = 'EST';
  config!: Options;

  constructor() {}
  ngOnInit(): void {
    this.config = highChartClockConfig({ tz: this.timeZone });
  }
}
